import React from "react";
import { DocumentsList } from "../../../../components";

const ListList = () => {
  return (
    <div className="w-full flex flex-col gap-4">
      <div className="w-full max-w-3xl">
        <h6>DocumentsList</h6>
        <div className="mt-4" />

        <DocumentsList
          newTab={true}
          data={[
            {
              name: "Invoice.pdf",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
            {
              name: "Report.docx",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
            {
              name: "Screenshot.png",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
          ]}
          type="modal"
        />

        <div className="mt-4" />
        <DocumentsList
          newTab={true}
          data={[
            {
              name: "Invoice.pdf",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
            {
              name: "Report.docx",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
            {
              name: "Screenshot.png",
              filePath:
                "https://tourism.gov.in/sites/default/files/2019-04/dummy-pdf_2.pdf",
            },
          ]}
          type="inner"
        />
      </div>
    </div>
  );
};

export default ListList;
